/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * Note:
 *
 * After a team discussion, we decided to copy over the dashboard legacy Multi Input component to remove development blocker, and
 * plan to rewrite this component in the future.
 *
 * For now, TypeScript linting is disabled because the components were not built in TypeScript.
 */
import { cx } from '@emotion/css';
import * as React from 'react';
import { Dropdown } from './Dropdown';
/**
 * @deprecated
 */
export class MultiValueField extends React.PureComponent {
    constructor() {
        super(...arguments);
        this.pasteInput = {};
        this._onPaste = (e) => {
            e.preventDefault();
            const clipboard = e.clipboardData.getData('Text');
            if (!clipboard) {
                return;
            }
            const trimValues = (values) => values.map((val) => val.trim());
            const formatSelectVals = (values) => values.map((val) => ({
                [this.pasteInput.labelKey]: val,
                [this.pasteInput.valueKey]: val,
            }));
            const filterOptions = (options) => {
                const { isOptionUnique, value, labelKey = 'label', valueKey = 'value' } = this.pasteInput.props;
                return options.filter((option) => isOptionUnique({
                    labelKey,
                    option: { label: option, value: option },
                    options: value,
                    valueKey,
                }));
            };
            const uniq = (values) => {
                const set = new Set();
                const result = [];
                for (let i = 0; i < values.length; i += 1) {
                    const value = values[i];
                    if (!set.has(value)) {
                        set.add(value);
                        result.push(value);
                    }
                }
                return result;
            };
            const selectValues = formatSelectVals(filterOptions(uniq(trimValues(clipboard.split(/[\s,]+/)))));
            if (selectValues.length > 0) {
                this.pasteInput.select.selectValue(selectValues);
            }
        };
        this._shouldKeyDownEventCreateNewOption = ({ keyCode }) => {
            const allowedCharacters = [
                9,
                13,
                32,
                188, // comma
            ];
            return allowedCharacters.indexOf(keyCode) > -1;
        };
    }
    render() {
        const multi = this.props.multi === undefined ? true : this.props.multi;
        const clearable = this.props.clearable === undefined ? true : this.props.clearable;
        const creatable = this.props.creatable === undefined ? true : this.props.creatable;
        return (React.createElement(Dropdown
        // eslint-disable-next-line react/jsx-props-no-spreading
        , Object.assign({}, this.props, { shouldKeyDownEventCreateNewOption: 
            // eslint-disable-next-line no-underscore-dangle
            this._shouldKeyDownEventCreateNewOption, inputProps: {
                // eslint-disable-next-line no-underscore-dangle
                onPaste: this._onPaste,
            }, 
            // removes "create {option}" messaging below input
            menuRenderer: () => { }, 
            // no results messaging was appearing occasionally below input, may have been a bug in react-select
            noResultsText: null, multi: multi, clearable: clearable, className: cx(this.props.className, 'no-indicator'), creatable: creatable, childRef: this, outerClassName: this.props.outerClassName, warning: this.props.warning, disabled: this.props.disabled, options: this.props.options, value: this.props.value })));
    }
}
//# sourceMappingURL=MultiValueField.js.map